import React from 'react';
import AppTitle from '../AppTitle';

const CancellationsAndRefunds = () => {
  return (
    <div>
      <AppTitle title={'Cancellations And Refunds'} from={'Home'} to='Contact' link='/' />

      <div className='container custom-container mt-10'>
        <div className='row gy-6'>
          <div className='col-12 '>
            <div className='contact-section1_content'>
              <p className='contact-section2__text' style={{ maxWidth: '100%' }}>
                <b>Cancellation and Refund Policy:</b>
                <br />
                Please note that we do not accept cancellations or offer refunds once an order has
                been placed. All sales are final.
                <br />
                <br />
                If you wish to modify or customise an order, please contact us via WhatsApp or Call
                at{' '}
                <b>
                  {' '}
                  <a href='https://wa.me/919945423080'>+91 99454 23080</a>
                </b>{' '}
                as soon as possible. We will do our best to accommodate your request, but once an
                order is processed or shipped, it cannot be canceled. By placing an order on
                <b> www.saycheezecakes.com</b>, you agree to these terms. We encourage you to review
                your order carefully before confirming your purchase.
                <br />
                <br />
                If you have any further questions, feel free to reach out to us on WhatsApp or email{' '}
                <b>
                  <a
                    className='social-item'
                    href='mailto:saycheezecakes@gmail.com'
                    target='_blank'
                    rel='noopener'
                  >
                    saycheezecakes@gmail.com
                  </a>
                </b>
                , and we will be happy to assist you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancellationsAndRefunds;
